import React from "react";

export default function Whatsapp({ className }) {
  return (
    <svg
      id="OUTLINE_copy_2"
      xmlns="http://www.w3.org/2000/svg"
      width="40.156"
      height="40.156"
      viewBox="0 0 40.156 40.156"
      className={className}
    >
      <path
        id="Path_556"
        data-name="Path 556"
        d="M20.078,0A20.078,20.078,0,1,0,40.156,20.078,20.077,20.077,0,0,0,20.078,0Z"
        fill="currentColor"
      />
      <path
        id="Path_557"
        data-name="Path 557"
        d="M17.893,7.371A9.272,9.272,0,0,0,10.866,22.7L9.6,25.923l2.825-1.8a9.107,9.107,0,0,0,5.473,1.8,9.276,9.276,0,0,0,0-18.552Zm5.868,13.14a3.41,3.41,0,0,1-2.037,1.643c-1.838.415-4.444-1.052-6.13-2.605-1.687-1.532-3.371-4.008-3.13-5.87a3.552,3.552,0,0,1,1.444-2.19,3.871,3.871,0,0,1,.744-.044c.306.021.57.044.658.218l.985,2.562c.065.2-.088.415-.285.658-.284.329-.328.35-.591.7a.467.467,0,0,0,0,.481,6.577,6.577,0,0,0,1.532,1.993,7.018,7.018,0,0,0,2.123,1.379,1.307,1.307,0,0,0,.5.065c.174-.021.284-.153.437-.35.284-.35.394-.482.635-.811.2-.241.393-.329.592-.22l2.232,1.03c.176.088.241.306.262.614a2.14,2.14,0,0,1,.024.745Z"
        transform="translate(2.197 3.43)"
        fill="#f6f5f1"
      />
    </svg>
  );
}
